import {Children, memo} from "react";
import {Box, Divider, Typography, useMediaQuery} from "@mui/material"
import {useTranslation} from "react-i18next"
import {theme} from "../../../utils";
import quotationImage from '../../../assets/images/other/quotation_marks.png'
import TranslationMsg from "./transMessage";

const styles = {
    reviewLabel: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        textTransform: "uppercase",
        ...theme.typography.opticianBodyRegular
    }
}

interface IVendorReviewProps {
    reviewData?: any
    vendorName?: any
}

const VendorReviews = (props: IVendorReviewProps) => {
    const {reviewData, vendorName} = props
    const {t} = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down(700))
    const clinicianReviews = reviewData?.clinicianReviews ? reviewData?.clinicianReviews : []

    return (
        <Box mt={"40px"} gap={'2rem'} flex={1} mb={"40px"}>
            {clinicianReviews?.length > 0 ?
                <>
                    <Divider/>
                    <Box display={'flex'} sx={{mt: '20px'}}>
                        {!isMobile ?
                            <img src={quotationImage} style={{width: "74px", height: "74px"}}
                                 alt="review-quotation"/> : null}
                        <Typography
                            sx={styles.reviewLabel}>{vendorName === "deepeye" ? t(TranslationMsg.CLINICAL_RESEARCHER_REVIEW) : t(TranslationMsg.CLINCIAN_REVIEW)}</Typography>
                    </Box>

                    <Box ml={isMobile ? "0px" : '74px'} mt={isMobile ? "24px" : "0px"}>
                        {Children.toArray(clinicianReviews.map((item: any, index: number) => (
                            <Box display={'flex'} key={index + 1}>
                                <Typography sx={{
                                    ...theme.typography.poppinsBodyRegular,
                                    fontSize: '20px',
                                    fontWeight: 300,
                                    marginBottom: "10px"
                                }}>
                                    {item?.reviewInfo}
                                    <span style={{
                                        ...theme.typography.poppinsBodyRegular,
                                        fontSize: '20px',
                                        fontWeight: 300,
                                    }}> {item?.reviewer}</span>
                                </Typography>
                            </Box>
                        )))}
                    </Box>
                </> : null
            }
        </Box>
    )
}

export default memo(VendorReviews)